import { Link } from "react-router-dom";

export default function AboutPreview() {
  return (
    <section id="about" className="bg-background-50 py-20 md:py-28">
      <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="text-xs tracking-[0.3em] uppercase text-accent-700 mb-4">
            ABOUT DAISAN
          </p>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight mb-4">
            DAISANについて
          </h2>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
            お客様の伴走者を目指します。
          </p>
      </div>
      <div className="mx-auto max-w-7xl px-4 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
        
        <div className="relative mb-4">
          <div className="relative rounded-lg overflow-hidden border border-background-200">
            <img
              src="images/about.jpg"
              alt="株式会社DAISAN 代表"
              className="w-full h-[520px] object-cover object-top"
            />
          </div>
          <div className="absolute -bottom-6 -right-4 md:-right-8 bg-primary-800 text-background-50 rounded-lg px-6 py-5 max-w-[260px]">
            <p className="text-accent-400 text-xs tracking-widest mb-2">CEO MESSAGE</p>
            <p className="text-sm leading-relaxed">
              「お客様の資産を、自分の物件のように守る」——それが創業当初からの約束です。
            </p>
          </div>
        </div>

        <div className="mb-0">
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4 text-justify">
            代表の山田は、20年間マンション清掃の第一線に立ち、その後、自らも不動産オーナーとなりました。<br></br><br></br>
            「清掃を依頼する側」と「する側」——両方の視点を持っているからこそ、
            オーナー様が本当に困っている場所と、余計に払っているコストの両方が見えます。
          </p>
          <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-8 text-justify">
            派手な広告や大規模な組織ではなく、地元で一件ずつ、長く付き合っていただける関係を築くこと。
            それが私たち株式会社DAISANの、変わらない姿勢です。
          </p>

          <div className="grid grid-cols-2 gap-4 mb-8">
            <div className="bg-background-100 rounded-md border border-background-200 p-4">
              <div className="font-heading text-2xl text-primary-700 mb-1">20年+</div>
              <div className="text-xs text-foreground-600">代表 清掃業界経験</div>
            </div>
            <div className="bg-background-100 rounded-md border border-background-200 p-4">
              <div className="font-heading text-2xl text-primary-700 mb-1">Owner</div>
              <div className="text-xs text-foreground-600">代表自身も不動産オーナー</div>
            </div>
          </div>

          <Link
            to="/about"
            className="inline-flex items-center gap-2 border border-primary-600 text-primary-700 hover:bg-primary-500 hover:text-background-50 px-6 py-3 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors"
          >
            私たちについて詳しく
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}